// Encoder limits shared by the two call paths (components/PeerWindow.svelte and links.js).
//
// A window is an ambient picture, not a screen share: 720p at 24 fps looks right at about
// 1.2 Mbit/s, while a browser left alone pushes 2.5 Mbit/s or more for the same picture.
// Every byte of a pre-connected link goes through the TURN relay, which is billed per
// gigabyte, so this cap is the single biggest lever on running cost (docs/costs.md).
// Audio stays on the browser default (Opus, about 32 kbit/s).
export const VIDEO_MAX_BITRATE = 1200000;

/** Apply the shared video limits to a sender. Harmless where unsupported. */
export function tuneVideoSender(sender) {
  if (!sender || typeof sender.getParameters !== "function") return;
  try {
    const params = sender.getParameters();
    params.degradationPreference = "maintain-framerate";
    if (Array.isArray(params.encodings) && params.encodings.length) {
      params.encodings.forEach((encoding) => { encoding.maxBitrate = VIDEO_MAX_BITRATE; });
    }
    const applied = sender.setParameters(params);
    if (applied && applied.catch) applied.catch(() => {});
  } catch (e) { /* unsupported */ }
}
